import React, { useEffect } from 'react';
import Settings from '../../../Settings/Settings'
import Grid from '@mui/material/Grid';
import OrderItemsElement from './OrderItemsElement'
import LoadingComponent from '../../LoadingComponent/LoadingComponent'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

export default function OrdersItemsComponent(props) {
    const [orderItems, setOrderItems] = React.useState([])
    const [loadingOrderItems, setLoadingOrderItems] = React.useState(false)
    useEffect(() => {
        getOrderItemsAction()
        }, []);

    const componentConstants = {
        ...props.componentConstants
      }
    
      const componentMethods = {
          ...props.componentMethods,
          getOrderItemsAction: () => {
            getOrderItemsAction()
          }
      }
      const componentProps = {
          ...props.componentProps
      }
      const getOrderItemsAction = () => {
        setOrderItems([])
        setLoadingOrderItems(true)
        let accountToken = ''
        if(componentMethods.getLocalStorage('user') && componentMethods.getLocalStorage('user').tokensHash) {
            accountToken = '?accountToken=' + componentMethods.getLocalStorage('user').tokensHash
        }
        componentMethods.ajax(Settings.API_URL + Settings.API_ENDPOINT_ORDER_ITEMS + props.ordersID + '/' + props.ordersSha + accountToken,{},'GET',null, (data) => {
            setLoadingOrderItems(false)
            setOrderItems(data.items)
        })
      }
return (<TableContainer component={Paper}>
        <Table>

                <TableHead>
                    <TableRow>
                        <TableCell>
                        {componentConstants.language.LANG_ORDER_ITEMS_ARTICLE_ID_AND_PRODUCT_ID}
                        </TableCell>
                        <TableCell>
                            {componentConstants.language.LANG_QUANTITY}
                        </TableCell>
                        <TableCell>
                            {componentConstants.language.LANG_ACTIONS}
                        </TableCell>
                    </TableRow>
                </TableHead>
            <TableBody>
            {
          orderItems.map((el, idx) => {
            return <OrderItemsElement key={idx} element={el} componentProps={componentProps} componentConstants={componentConstants} componentMethods={componentMethods} />
                
            })
            }
            </TableBody>
            {
                loadingOrderItems ?
                <Grid item xl={12} md={12} sm={12}>
                    <LoadingComponent />
                </Grid>
                :
                null
            }
        </Table>
        </TableContainer>
  );
}